import * as React from "react";
import * as PopoverPrimitive from "@radix-ui/react-popover";
import { cn } from "../../lib/utils";

export const Popover = PopoverPrimitive.Root;
export const PopoverTrigger = PopoverPrimitive.Trigger;
export const PopoverAnchor = PopoverPrimitive.Anchor;

type ContentProps = React.ComponentPropsWithoutRef<
  typeof PopoverPrimitive.Content
> & {
  ref?: React.Ref<React.ComponentRef<typeof PopoverPrimitive.Content>>;
};

export function PopoverContent({
  className,
  align = "start",
  sideOffset = 6,
  ref,
  ...props
}: ContentProps) {
  return (
    <PopoverPrimitive.Portal>
      <PopoverPrimitive.Content
        ref={ref}
        align={align}
        sideOffset={sideOffset}
        className={cn(
          "z-50 w-(--radix-popover-trigger-width) overflow-hidden rounded-md border border-outline-variant/40 bg-surface-container-lowest p-0 text-on-surface shadow-md data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:animate-in data-[state=open]:fade-in-0",
          className,
        )}
        {...props}
      />
    </PopoverPrimitive.Portal>
  );
}
